RivalIQ.apps.SocialPosts.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.loadCompanyData = function (curation) {

        /*
         * NOTE load company data to set earliest post date value
         * Needed for the custom date range and social data freshness
         * indicator
         */
        return RivalIQ.data.companyData.fetchPresences(curation.getProps())
            .then(function (companyData) {
                curation.companyData = companyData;
            });
    };


    filters.loadPostTags = function (curation) {

        return RivalIQ.postTags.data.PostTags.fetch()
            .then(function (postTags) {
                curation.postTags = postTags;

                const postTagIds = RivalIQ.postTags.utils.getPostTagIds(curation.getProp('postTagIds'));
                if (!_.isEmpty(postTagIds)) {
                    // If all post tag ids are invalid, redirect to filter none of them. This will have a side-effect of failing
                    // an export if we're exporting, which is desired.

                    const validPostTagIds = _.keyBy(_.map(postTags, 'id'));
                    const allInvalid = _.every(postTagIds, function (postTagId) {
                        return (postTagId !== '__UNTAGGED__' && !validPostTagIds[postTagId]);
                    });

                    if (allInvalid) {
                        return curation.getPath({
                            postTagIds: undefined,
                            postTagExclude: undefined,
                            postTagConjunction: undefined
                        });
                    }
                }
            });
    };

});
